import colors from "../../../styles/colors"
import fonts from "../../../styles/fonts"
import breakpoints from "../../../styles/breakpoints"

const H1Style = `
${fonts.selfModern};
color: ${colors.black};
font-size: 32px;
line-height: 41px;

@media (min-width: ${breakpoints.md}) {
  font-size: 44px;
  line-height: 55px;
}

@media (min-width: ${breakpoints.lg}) {
  font-size: 50px;
  line-height: 62px;
}`

const H2Style = `
  ${fonts.selfModern};
  color: ${colors.black};
  font-size: 26px;
  line-height: 36px;

  @media (min-width: ${breakpoints.md}) {
    font-size: 34px;
    line-height: 41px;
  }
  
  @media (min-width: ${breakpoints.lg}) {
    font-size: 34px;
    line-height: 46px;
  }
`

const H3Style = `
  ${fonts.selfModern};
  color: ${colors.black};
  font-size: 16px;
  line-height: 23px;

  @media (min-width: ${breakpoints.md}) {
    font-size: 22px;
    line-height: 31px;
  }
  
  @media (min-width: ${breakpoints.lg}) {
    font-size: 24px;
    line-height: 34px;
  }
`

export { H1Style, H2Style, H3Style }
